<template>
  <div class="headerBg">
    <div class="textheader">
      <div class="main">
        <div class="first">欢迎访问 高校教材监测使用平台~</div>
        <div class="second">
          <div class="wxcodeimg">
            <div class="wxcode">
              <img class="barcode" src="../../assets/img/wximg.jpg" alt="" />
              <p class="scan">扫一扫</p>
            </div>
          </div>
          <div class="joinadmin" @click="gotoAdmin">进入后台管理系统 >></div>
        </div>
      </div>
    </div>
    <div class="mainHeader">
      <div class="title-mask">
        <p class="proName">高校教材监测使用平台</p>
        <ul class="headerul">
          <li
            :key="index"
            v-for="(nav, index) in navs"
            :class="{ active: index == current }"
            @click="togoLink(index)"
          >
            {{ nav }}
          </li>
        </ul>
        <div></div>
      </div>
      <div class="rightbg">
        <!-- <el-input
          id="search"
          v-show="isShowSearch"
          class="searchInput"
          v-model="searchName"
          placeholder="请输入搜索内容"
          suffix-icon="el-icon-search"
        ></el-input>
        <img
          v-show="!isShowSearch"
          class="simg"
          src="../../assets/img/searchIcon.png"
          alt=""
          @click="showInput"
        /> -->
        <!-- <div class="user" v-show="loginBut">
          <div @click="phonedialogVisible = true">登录</div>
        </div> -->
        <div class="divcard right" v-show="userInfo" @click="pushChooseBook">
          <!-- <span class="numberdiv"></span> -->
          <img class="cartimg" src="../../assets/img/redcaricon.png" alt="" />
          <span>我的选书</span>
        </div>
        <div class="touxiang" v-show="userInfo">
          <div class="loginName">
            <el-dropdown trigger="click" @command="handleCommand">
              <span>
                <!-- <div class="touxiangPic">
                  <el-avatar
                    class="resPicUrl"
                    :src="resPicUrl"
                    @error="errorHandler"
                  >
                    <img src="../../assets/img/morentouxiangicon.png" />
                  </el-avatar>
                </div> -->
                <p class="el-dropdown-link resPhone">
                  {{ resnickname || '用户账户' }}
                  <i class="el-icon-arrow-down"></i>
                </p>
              </span>
              <el-dropdown-menu slot="dropdown" class="dropdown">
                <el-dropdown-item command="userMsg">
                  <img
                    class="left-icon"
                    src="../../assets/img/user-msg.png"
                    alt=""
                  />
                  个人资料</el-dropdown-item
                >
                <el-dropdown-item command="cbook"
                  ><img
                    class="left-icon"
                    src="../../assets/img/cbook-icon.png"
                    alt=""
                  />
                  选书清单</el-dropdown-item
                >
                <el-dropdown-item command="applyBook"
                  ><img
                    class="left-icon"
                    src="../../assets/img/applyb-icon.png"
                    alt=""
                  />
                  申请样书列表</el-dropdown-item
                >
                <el-dropdown-item command="publishBook"
                  ><img
                    class="left-icon"
                    src="../../assets/img/publish-icon.png"
                    alt=""
                  />
                  出版教材</el-dropdown-item
                >
                <el-dropdown-item command="huiGao"
                  ><img
                    class="left-icon"
                    src="../../assets/img/greyliuyan.png"
                    alt=""
                  />
                  回告管理</el-dropdown-item
                >
                <el-dropdown-item command="userPsw"
                  ><img
                    class="left-icon"
                    src="../../assets/img/userpsw-icon.png"
                    alt=""
                  />
                  账号密码</el-dropdown-item
                >
                <el-dropdown-item command="loginOut"
                  ><img
                    class="left-icon"
                    src="../../assets/img/logout-icon.png"
                    alt=""
                  />
                  退出登录</el-dropdown-item
                >
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </div>
      </div>
    </div>
    <!-- 手机验证登录 -->
    <el-dialog
      title
      :visible.sync="phonedialogVisible"
      width="550px"
      :before-close="handleClose"
    >
      <div class="login">
        <div class="loginTit">
          <div></div>
          <div>{{ phoneTit }}</div>
          <div></div>
        </div>
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="100px"
          class="demo-ruleForm loginFrom"
        >
          <el-form-item label="账号:" prop="username">
            <el-input
              v-model="ruleForm.username"
              id="loginInput1"
              placeholder="请输入账号"
            ></el-input>
          </el-form-item>
          <el-form-item label="密码:" prop="password">
            <el-input
              type="password"
              id="loginInput2"
              v-model="ruleForm.password"
              placeholder="请输入密码"
            ></el-input>
          </el-form-item>
        </el-form>
        <div class="loginBut" @click="phoneInfo('ruleForm')">立即登录</div>
      </div>
    </el-dialog>

    <el-dialog
      title
      :visible.sync="wechatdialogVisible"
      width="550px"
      :before-close="handleClose"
    >
      <div class="login">
        <div class="wechatTip"></div>
        <div class="line"></div>
        <div class="loginTip">
          <span>没有账号？</span>
          <span @click="register()">立即注册</span>
          <span
            @click=";(wechatdialogVisible = false), (logindialogVisible = true)"
            >账号登录>></span
          >
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { api } from '../../assets/api/axios'
import Qs from 'qs'
import { mapMutations, mapState, mapGetters } from 'vuex'
import axios from 'axios'
import md5 from 'js-md5'
export default {
  data() {
    var checkPhone = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('手机号不能为空'))
      } else {
        const reg = /^1[3|4|5|7|8][0-9]\d{8}$/
        if (reg.test(value)) {
          callback()
        } else {
          return callback(new Error('请输入正确的手机号'))
        }
      }
    }
    var validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入密码'))
      } else {
        if (this.ruleForm.checkPass !== '') {
          this.$refs.ruleForm.validateField('checkPass')
        }
        callback()
      }
    }

    return {
      navs: ['首页', '教材库', '出版社', '教材培训'],
      current: 0,
      isShowSearch: '',
      searchName: '',
      menuStyle: {
        'border-bottom-color': 'white',
      },
      defImg: '../../assets/img/morentouxiangicon.png',
      logindialogVisible: false,
      ruleForm: {
        account: '',
        password: '',
        pass: '',
        checkPass: '',
        code: '',
      },
      rules: {
        username: [{ required: true, trigger: 'blur', message: '请输入账号' }],
        password: [{ required: true, message: '请输入密码', trigger: 'blur' }],
      },
      registerdialogVisible: false,
      wechatdialogVisible: false,
      loginBut: true,
      userInfo: false,
      nickname: '',
      count: '',
      showcode: true,
      showcodes: false,
      timer: null,
      imgUrl: require('../../assets/img/touxiang.jpg'),
      phonedialogVisible: false,
      phoneTit: '账号登录',
    }
  },
  computed: {
    ...mapGetters(['resPicUrl', 'bookCount', 'resnickname']),
  },
  watch: {
    $route(to, from) {
      console.log(222, 'tooo====>', to, from)
      this.getIndex(to.path)
      // this.current = localStorage.getItem('index') || 0
      // to , from 分别表示从哪跳转到哪，都是一个对象
      // to.path  ( 表示的是要跳转到的路由的地址 eg: /home );
    },
  },
  created() {
    this.iftoken()
    console.log('this.$route====>', this.$route)

    this.getIndex(this.$route.path)
    //
    var list = localStorage.getItem(`${this.resPhone}noSubmittedMatList`)
    if (list) {
      list = JSON.parse(list)
    } else {
      list = []
    }
    this.$store.commit('setBookCount', list.length > 0 ? list.length : 0)
    console.log('======>', this.resnickname)

    var _self = this
    document.onkeydown = function (e) {
      var key = window.event.keyCode
      if (key == 13) {
        console.log('=====>目标===', e)
        if (e.target == document.getElementById('search')) {
          _self.searchAction()
        } else if (
          e.target === document.getElementById('loginInput1') ||
          e.target === document.getElementById('loginInput2')
        ) {
          console.log('====>登录')
          _self.phoneInfo('ruleForm')
        }
        // _self.login()
      }
    }
  },
  mounted() {},
  methods: {
    getIndex(path) {
      if (path.indexOf('/onLine') >= 0) {
        this.current = 1
      } else if (path.indexOf('/teachingmat') >= 0) {
        this.current = 0
      } else if (path.indexOf('/press') >= 0) {
        this.current = 2
      } else if (path.indexOf('/booktrain') >= 0) {
        this.current = 3
      }
    },
    gotoAdmin() {
      window.open('http://hngx.maisuiedu.com')
    },
    showInput() {
      this.isShowSearch = true
    },
    searchAction() {
      this.isShowSearch = false
    },
    errorHandler() {
      return true
    },
    togoLink(index) {
      localStorage.setItem('index', index)
      if (index == 0) {
        this.$router.push({ path: '/' })
        return false
      }
      if (index == 1) {
        this.$router.push({ path: '/onLine' })
        return false
      }
      if (index == 2) {
        this.$router.push({ path: '/press' })
        return false
      }
      if (index == 3) {
        this.$router.push({ path: '/booktrain' })
        return false
      }
    },
    pushChooseBook() {
      this.$router.push({ path: '/myBookList' })
    },
    handleCommand(command) {
      switch (command) {
        case 'userMsg':
          {
            this.$router.push({ path: '/center/self' })
          }
          break
        case 'cbook':
          {
            this.$router.push({ path: '/center/collection' })
          }
          break
        case 'applyBook':
          {
            this.$router.push({ path: '/center/apply' })
          }
          break
        case 'publishBook':
          {
            this.$router.push({ path: '/center/publish' })
          }
          break
        case 'userPsw':
          {
            this.$router.push({ path: '/center/password' })
          }
          break
        case 'loginOut':
          {
            window.localStorage.clear()
            this.$router.push('/')
            this.$router.go(0)
          }
          break
          {
            this.$router.push({ path: '/center/apply' })
          }
          break
        case 'publishBook':
          {
            this.$router.push({ path: '/center/publish' })
          }
          break
        case 'userPsw':
          {
            this.$router.push({ path: '/center/password' })
          }
          break
        case 'loginOut':
          {
            window.localStorage.clear()
            this.$router.push('/')
            this.$router.go(0)
          }
          break
        case 'huiGao':
          {
            this.$router.push({ path: '/center/liuyan' })
          }
          break
        default:
          break
      }
    },
    handleClose(done) {
      this.$confirm('确认关闭？')
        .then((_) => {
          done()
        })
        .catch((_) => {})
    },
    wxgetCode() {
      this.registerdialogVisible = false
      this.logindialogVisible = true
    },
    submitForm(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          let res = await api.post('/front/login/doLogin.do', {
            account: this.ruleForm.account,
            password: this.ruleForm.password,
          })
          this.user(res)
        } else {
          return false
        }
      })
    },
    async user(res) {
      var result = res.data
      if (res.data.status == 0) {
        this.nickname = result.data.name
        this.loginBut = false
        this.userInfo = true
        this.logindialogVisible = false
        this.$store.commit('getPicUrl', result.data.imagesUrl)
        this.$store.commit('getnickname', result.data.name)
        this.$store.commit('getName', result.data.name)
        this.$store.commit('getFid', result.data.id)
        this.$store.commit('getSchoolId', result.data.schoolId)
        this.$store.commit('getSchName', result.data.schoolName)
        this.$store.commit('getSchoolLevel', result.data.schoolLevel)
        this.$store.commit('getProfessional', result.data.professional)
        this.$store.commit(
          'setBookSelectionAuthority',
          result.data.bookSelectionAuthority
        )
        this.$store.commit('getPhone', result.data.mobilephone)
        window.localStorage.setItem('Token', result.data.token)
      } else {
        this.$message.error(result.msg)
      }
    },
    iftoken() {
      let token = window.localStorage.getItem('Token')
      if (token !== null) {
        this.loginBut = false
        this.userInfo = true
      } else {
        this.loginBut = true
        this.userInfo = false
      }
    },
    phoneInfo(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          let password = md5(md5(this.ruleForm.password))
          let res = await axios({
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded',
            },
            method: 'post',
            url: 'login',
            data: Qs.stringify({
              username: this.ruleForm.username,
              password: password,
            }),
          })
          if (res.data.status == 0) {
              this.$message({
                message: '登录成功',
                type: 'success'
              });
            this.phonedialogVisible = false
            this.userInfo = true
            this.user(res)
            location.reload()
          } else {
             this.$message({
          message: res.data.msg,
          type: 'error'
        });
          }
        } else {
          return false
        }
      })
    },
    resetForm(formName) {
      this.$refs[formName].resetFields()
    },
    register() {
      this.logindialogVisible = false
      this.registerdialogVisible = true
    },
    wxlogin() {
      this.logindialogVisible = false
      this.wechatdialogVisible = true
    },
  },
}
</script>>
<style>
.el-menu--horizontal > .el-submenu.is-active .el-submenu__title {
  border: none !important;
}
.el-avatar {
  background: white !important;
}
/* .dropdown {
  width: 120px;
} */
.dropdown .el-dropdown-menu__item {
  width: 120px !important;
  min-width: 120px;
  text-align: center;
  line-height: 40px;
}
/* .el-popper[x-placement^="bottom"] .popper__arrow {
  left: 50% !important;
} */
</style>
<style lang="scss" scoped>
.proName {
  color: #fff;
  font-size: 16px;
}
.left-icon {
  width: 15px;
  height: 15px;
  object-fit: contain;
  margin-right: 5px;
  margin-bottom: -2px;
}
.el-dropdown-menu__item {
  text-align: left !important;
  border-bottom: 1px solid #f2f2f2;
}
.searchInput {
  width: 150px;
  background-color: white;
  height: 30px;
  border-radius: 4px;
}
.searchInput /deep/.el-input__inner {
  height: 32px !important;
  line-height: 32px !important;
}
.searchInput /deep/.el-input__icon {
  line-height: 32px !important;
}
.rightbg {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
.simg {
  padding: 8px;
  width: 16px;
  height: 16px;
}
.title-mask {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.right {
  margin-right: 8px;
}
.cartimg {
  width: 20px;
  height: 19px;
  display: inline-block;
  vertical-align: middle;
  margin-top: -2px;
  margin-right: 5px;
}
.numberdiv {
  position: absolute;
  width: 12px;
  height: 12px;
  background: #0082f0;
  border-radius: 6px;
  line-height: 12px;
  font-size: 12px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffffff;
  left: 32px;
  top: 5px;
}
.divcard {
  width: 132px;
  height: 36px;
  font-size: 14px;
  color: white;
  line-height: 36px;
  text-align: center;
  display: inline-block;
  vertical-align: middle;
  margin-left: 20px;
  position: relative;
}
.title-en {
  font-size: 11px;
  font-family: Microsoft YaHei;
  font-weight: 500;
  color: #2f3a4c;
  line-height: 24px;
}
.schoolName {
  display: block;
  float: left;
  font-size: 33px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #2f3a4c;
  line-height: 33px;
  width: 500px;
}
.wxcode {
  position: absolute;
  left: -55px;
  top: 45px;
  width: 122px;
  height: 143px;
  background: #ffffff;
  box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.21);
  display: none;
  z-index: 100;
  .barcode {
    width: 106px;
    height: 106px;
    margin: 8px;
  }
}
.scan {
  text-align: center;
  font-size: 12px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #666666;
}

.wxcodeimg:hover .wxcode {
  display: block;
}
.wxcodeimg {
  position: relative;
}
.active {
  color: #76fff4 !important;
}
.headerul {
  height: 52px;
  background: #222222;
}
.headerul li {
  float: left;
  width: 120px;
  height: 52px;
  text-align: center;
  line-height: 52px;
  font-size: 16px;
  color: #ffffff;
  font-family: Microsoft YaHei;
  font-weight: bold;
  cursor: default;
}
.mainHeader {
  width: 1200px;
  margin: 0 auto;
  color: #111111;
  font-size: 13px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.el-menu--horizontal > .el-menu-item.is-active {
  border-bottom: 2px solid #ffffff;
}
.el-menu--horizontal > .el-submenu.is-active .el-submenu__title {
  border-bottom: 2px solid #ffffff !important;
}
.el-submenu.is-active .el-submenu__title {
  border-bottom-color: white;
}
.searchbg {
  width: 30px;
  height: 30px;
}
.headerBg {
  width: 100%;
  background-color: #222222;
  .mainHeader {
    color: #111111;
    overflow: hidden;
    font-size: 13px;
    height: 60px;
    .first {
      margin-right: 25px;
      // width: 64px;
      height: 37px;
      margin-bottom: 8px;
      float: left;
    }
    .user {
      cursor: pointer;
      display: flex;
      text-align: right;
      margin-right: 10px;
      font-size: 13px;
      margin-left: 25px;
      float: right;
      color: white;
    }
  }
}
.touxiang {
  float: right;
  overflow: hidden;
  // height: 40px;
  .touxiangPic {
    float: left;
    margin-left: 10px;
    height: 40px;
    width: 40px;
    overflow: hidden;
    border-radius: 50%;
    .resPicUrl {
      width: 40px;
      height: 40px;
    }
    img {
      width: 100%;
      height: 100%;
    }
  }

  .loginName {
    float: left;
    height: 47px;
    line-height: 47px;
    // max-width: 124px;
    overflow: hidden;
    cursor: pointer;
    .resPhone {
      margin-left: 5px;
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: white;
      height: 47px;
      float: left;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      // width: 65px;
    }
  }
}
.login {
  margin: 0 70px 0px;
  width: 365px;
  .loginTit {
    overflow: hidden;
    margin: 0 68px 40px;
    text-align: center;
    :nth-child(1) {
      width: 40px;
      height: 1px;
      background: rgba(204, 204, 204, 1);
      float: left;
      margin-top: 10px;
    }
    :nth-child(2) {
      font-size: 18px;
      font-weight: bold;
      color: rgba(51, 51, 51, 1);
      float: left;
      margin: 0 20px;
    }
    :nth-child(3) {
      width: 40px;
      height: 1px;
      background: rgba(204, 204, 204, 1);
      float: left;
      margin-top: 10px;
    }
  }
  .loginBut {
    width: 360px;
    height: 42px;
    background: #0082f0;
    font-size: 16px;
    color: rgba(255, 255, 255, 1);
    line-height: 42px;
    text-align: center;
    margin-top: 40px;
    margin-bottom: 30px;
  }
  .loginTip {
    margin: 20px 0 0;
    font-size: 14px;
    color: rgba(51, 51, 51, 1);
    span:nth-child(2) {
      font-size: 14px;
      color: #0082f0;
      cursor: pointer;
    }
    span:nth-child(3) {
      margin-left: 160px;
      font-size: 14px;
      color: rgba(153, 153, 153, 1);
    }
  }
  .line {
    width: 360px;
    height: 1px;
    background: rgba(238, 238, 238, 1);
    margin: 70px 0 30px;
  }
  .wechat {
    margin: 0 auto;
    font-size: 14px;
    color: rgba(51, 51, 51, 1);
    text-align: center;
    div {
      margin-bottom: 30px;
    }
    img {
      width: 26px;
      height: 26px;
      margin-bottom: 30px;
    }
  }
  .phonesend {
    width: 130px;
    height: 40px;
    background: rgba(246, 246, 246, 1);
    font-size: 14px;
    color: rgba(102, 102, 102, 1);
    text-align: center;
    line-height: 38px;
    position: absolute;
    top: 0;
    right: 0;
    cursor: pointer;
  }
}
.qrImg {
  width: 282px;
  height: 339px;
  margin-left: 40px;
}
.wechatTip {
  text-align: center;
  margin: 20px 0 30px;
  font-size: 14px;
  color: rgb(235, 114, 114);
}
</style>
<style lang="scss">
.loginFrom .el-form-item__error {
  margin-left: 85px;
}
.phone {
  width: 12px;
  height: 21px;
  vertical-align: middle;
  display: inline-block;
  margin-right: 5px;
}
.imgtext,
.joinadmin {
  display: inline-block;
  color: #999999;
  font-size: 13px;
  line-height: 36px;
  font-family: Microsoft YaHei;
  font-weight: 400;
}
.textheader {
  width: 100%;
  height: 36px;
  background: #f8f8f8;
  color: #2f3a4c;
  .first {
    color: #2f3a4c;
    float: left;
    margin-top: 12px;
    font-size: 13px;
    font-family: Microsoft YaHei;
    font-weight: 400;
  }
  .second {
    float: right;
    display: flex;
    align-items: center;
    div {
      float: left;
      margin-left: 30px;
      cursor: pointer;
      &:hover {
        color: #0082f0;
      }
    }
  }
}
.login {
  .el-input {
    width: 280px;
  }
  .el-form-item__label {
    width: 85px !important;
  }
  .el-form-item__content {
    margin-left: 0 !important;
  }
}
</style>
